import { Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, startWith } from 'rxjs/operators';

import { UntypedFormGroup } from '@angular/forms';

import { map } from 'rxjs/operators';
import { CourtBookingSaveFacade } from '../../+store/court-booking-save.facade';
import { CourtBookingSaveInputModel } from '../../models/court-booking-save-input.model';

@Component({
    selector: 'app-court-booking-save-details',
    templateUrl: './court-booking-save-details.component.html',
    styleUrls: ['./court-booking-save-details.component.scss'],
    standalone: false
})
export class CourtBookingSaveDetailsComponent implements OnInit, OnDestroy {
    @Input() form: UntypedFormGroup;
    @Input() isMainPlayerSelected: boolean;
    @Input() courtBookingInput: CourtBookingSaveInputModel;
    @Input() fromLoaded: boolean;

    courts$ = this.courtBookingSaveFacade.courts$;
    courtOptions$ = this.courtBookingSaveFacade.courtOptions$;
    timeSlots$ = this.courtBookingSaveFacade.timeSlots$;
    isCourtSelected$ = this.courtBookingSaveFacade.isCourtSelected$;
    isCategoryOptionSelected$ = this.courtBookingSaveFacade.isCategoryOptionSelected$;
    isTimePeriodSelected$ = this.courtBookingSaveFacade.isTimePeriodSelected$;
    availableTimeSlots$ = this.courtBookingSaveFacade.availableTimeSlots$;

    typeSelectEnabled$ = this.courtBookingSaveFacade.typeSelectEnabled$;
    timePeriodEnabled$ = this.courtBookingSaveFacade.timePeriodEnabled$;
    timeEnabled$ = this.courtBookingSaveFacade.timeEnabled$;

    hasNoAvailableTimeSlots$ = this.availableTimeSlots$.pipe(map(x => x.loaded && !x.hasItems));

    selectedTimeSlotUnavailabilityMessage$ = this.courtBookingSaveFacade.selectedTimeSlotsUnavailabilityMessage$;
    isSelectedTimeSlotUnavailable$ = this.courtBookingSaveFacade.isSelectedTimeSlotUnavailable$;

    @ViewChild('timeDropdownContainer') timeDropdownContainer: ElementRef;

    private _modalBackground: HTMLElement | null = null;

    subscription: Subscription = new Subscription();
    constructor(private courtBookingSaveFacade: CourtBookingSaveFacade) { }

    @HostListener('document:click')
    onDocumentClick(): void {
        setTimeout(() => {
            const el = this.timeDropdownContainer?.nativeElement;
            if (el && !el.querySelector('.bcu-dropdown-list-container')) {
                this.resetTimeDropdownPadding();
            }
        });
    }

    private resetTimeDropdownPadding(): void {
        if (this._modalBackground) {
            this._modalBackground.style.paddingBottom = '';
            this._modalBackground = null;
        }
    }

    updateTimeDropdownPosition(): void {
        setTimeout(() => {
            const el = this.timeDropdownContainer.nativeElement;
            const dropdownList: HTMLElement = el.querySelector('.bcu-dropdown-list-container');
            if (!dropdownList) return;

            const modal = el.closest('.modal') as HTMLElement;
            const modalBackground = el.closest('.court-booking-save-body') as HTMLElement;
            const whiteBox = el.closest('.modal-save-content') as HTMLElement;
            if (!modal || !modalBackground || !whiteBox) return;

            this._modalBackground = modalBackground;

            const dropdownRect = dropdownList.getBoundingClientRect();
            const whiteBoxRect = whiteBox.getBoundingClientRect();

            // Extend blue background to cover however far the dropdown overflows below the white box
            const overflowBelowWhiteBox = dropdownRect.bottom - whiteBoxRect.bottom;
            if (overflowBelowWhiteBox > 0) {
                modalBackground.style.paddingBottom = `${overflowBelowWhiteBox + 20}px`;
            }

            // Scroll modal to bring full dropdown into viewport
            const viewportOverflow = dropdownRect.bottom - window.innerHeight;
            if (viewportOverflow > 0) {
                modal.scrollTop += viewportOverflow + 8;
            }
        });
    }

    ngOnInit(): void {
        this.subscription.add(
            this.form.controls.courtId.valueChanges
                .pipe(
                    startWith(this.form.controls.courtId.value),
                    distinctUntilChanged()
                )
                .subscribe(value => {
                    this.form.patchValue({
                        categoryOptionsId: null,
                        timeSlot: null,
                        secondPlayer: null,
                        thirdPlayer: null,
                        fourthPlayer: null
                    });
                })
        );
        this.subscription.add(
            this.form.controls.timeSlot.valueChanges
                .pipe(
                    startWith(this.form.controls.timeSlot.value),
                    distinctUntilChanged(),
                    filter(x => !!x)
                )
                .subscribe(value => {
                    this.courtBookingSaveFacade.loadAvailableTimeSlots(value, null, this.courtBookingInput.timeFrom);
                })
        );
        this.subscription.add(
            this.form.controls.categoryOptionsId.valueChanges
                .pipe(
                    startWith(this.form.controls.categoryOptionsId.value),
                    distinctUntilChanged()
                ).subscribe(value => {
                    this.form.patchValue({
                        secondPlayer: null,
                        thirdPlayer: null,
                        fourthPlayer: null
                    });
                    this.courtBookingSaveFacade.clearPlayers();
                })
        );

        this.subscription.add(
            this.form.controls.date.valueChanges
                .pipe(distinctUntilChanged((prev, curr) => (prev && curr && prev.value === curr.value) || (!prev && !curr)))
                .subscribe(value => {
                    if (this.form.controls.timeSlot.value) {
                        this.courtBookingSaveFacade.loadAvailableTimeSlots(null, value, this.courtBookingInput.timeFrom);
                    }
                    if (value && this.fromLoaded) {
                        this.courtBookingSaveFacade.loadCourts(value);
                    }
                })
        );
    }

    ngOnDestroy(): void {
        this.resetTimeDropdownPadding();
        this.subscription.unsubscribe();
    }
}
